import {
  type BaseFixedIncomeCategory,
  EquitiesSectorEnum,
  FixedIncomeCategoryEnum,
  type BaseEquitiesSector,
} from '@egw/api'

export const BaseEquitiesInit: BaseEquitiesSector = {
  [EquitiesSectorEnum.HEALTHCARE]: {
    value: 0,
    key: EquitiesSectorEnum.HEALTHCARE,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.CONSUMER]: {
    value: 0,
    key: EquitiesSectorEnum.CONSUMER,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.FINANCIAL]: {
    value: 0,
    key: EquitiesSectorEnum.FINANCIAL,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.TECHNOLOGY]: {
    value: 0,
    key: EquitiesSectorEnum.TECHNOLOGY,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.INDUSTRY]: {
    value: 0,
    key: EquitiesSectorEnum.INDUSTRY,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.ENERGY]: {
    value: 0,
    key: EquitiesSectorEnum.ENERGY,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.REAL_ESTATE]: {
    value: 0,
    key: EquitiesSectorEnum.REAL_ESTATE,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
  [EquitiesSectorEnum.MEDIA]: {
    value: 0,
    key: EquitiesSectorEnum.MEDIA,
    recommendedRange: {
      allowedMaxAllocationPercent: 0.32,
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxPercent: 0,
    },
  },
}

export const BaseFixedIncomeInit: BaseFixedIncomeCategory = {
  [FixedIncomeCategoryEnum.CORPORATE_BONDS]: {
    recommendedRange: {
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxAllocationPercent: 0.32,
      allowedMaxPercent: 0,
    },
    value: 0,
    key: FixedIncomeCategoryEnum.CORPORATE_BONDS,
  },
  [FixedIncomeCategoryEnum.GOVERNMENT_BONDS]: {
    recommendedRange: {
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxAllocationPercent: 0.32,
      allowedMaxPercent: 0,
    },
    value: 0,
    key: FixedIncomeCategoryEnum.GOVERNMENT_BONDS,
  },
  [FixedIncomeCategoryEnum.HIGH_YIELD_BONDS]: {
    recommendedRange: {
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxAllocationPercent: 0.32,
      allowedMaxPercent: 0,
    },
    value: 0,
    key: FixedIncomeCategoryEnum.HIGH_YIELD_BONDS,
  },
  [FixedIncomeCategoryEnum.INTERNATIONAL_BONDS]: {
    recommendedRange: {
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxAllocationPercent: 0.32,
      allowedMaxPercent: 0,
    },
    value: 0,
    key: FixedIncomeCategoryEnum.INTERNATIONAL_BONDS,
  },
  [FixedIncomeCategoryEnum.MUNICIPAL_BONDS]: {
    recommendedRange: {
      recommendedPercent: 0,
      allowedMinPercent: 0,
      allowedMaxAllocationPercent: 0.32,
      allowedMaxPercent: 0,
    },
    value: 0,
    key: FixedIncomeCategoryEnum.MUNICIPAL_BONDS,
  },
}
